import { useCallback, useEffect, useRef, useState } from "react";

export default function useMediaQuery(query: string): boolean {
  const mediaQuery = useRef(window.matchMedia(query));
  const [matches, setMatches] = useState(mediaQuery.current.matches);

  const handleMediaEvent = useCallback((mql) => {
    setMatches(mql.matches);
  }, []);

  useEffect(() => {
    const mq = mediaQuery.current;
    mq.addListener(handleMediaEvent);
    return () => {
      mq.removeListener(handleMediaEvent);
    };
  }, [handleMediaEvent]);

  return matches;
}
